import { GraphQLVehicleModelsRequester } from '@cobliteam/api-lib';
import type { Branding } from '@cobliteam/api-lib/src/__generated__/graphql';
import { type UseQueryOptions, useQuery } from '@tanstack/react-query';

export const QUERY_KEY = 'VEHICLE_MODELS';

const graphQLVehicleModelsRequester = () => new GraphQLVehicleModelsRequester();

const useVehicleModels = () => {
  const getVehicleModels = (options?: Partial<UseQueryOptions<Branding[]>>) =>
    useQuery<Branding[]>({
      queryKey: [QUERY_KEY],
      ...options,
      queryFn: async () => graphQLVehicleModelsRequester().getVehicleModels(),
    });

  return {
    getVehicleModels,
  };
};

export default useVehicleModels;
